import {
  getLocalItem,
  setLocalItem,
  removeLocalItem,
} from "shared/utils/localStorageAccess";

export const ORGANIZATION_SELECTION_KEY = "rme-userConfig";
export const SELECTED_RPIDS_KEY = "rme-selectedRpidsForGroup";
export const DECOMPOSE_GROUPS_KEY = "rme-decomposeGroups";
export const SELECTED_LOCATIONS_KEY = "rme-selectedLocationMmids";
export const SELECTION_OWNER_KEY = "rme-selectionOwner";

const USER_SELECTION_KEYS = [
  ORGANIZATION_SELECTION_KEY,
  SELECTED_RPIDS_KEY,
  DECOMPOSE_GROUPS_KEY,
  SELECTED_LOCATIONS_KEY,
  SELECTION_OWNER_KEY,
];

function NormalizeEmail(email) {
  return typeof email === "string" ? email.trim().toLowerCase() : "";
}

// Removes every browser-persisted, per-user header selection so the next user starts clean.
export function ClearUserSelectionCache() {
  USER_SELECTION_KEYS.forEach((key) => removeLocalItem(key));
}

// Ties the cached selection to the signed-in user. A cache written for anyone else (or by a
// build that did not record an owner) is discarded. Returns true when the cache was discarded.
export function ClaimUserSelectionCache(email) {
  const normalizedEmail = NormalizeEmail(email);
  if (!normalizedEmail) return false;

  if (getLocalItem(SELECTION_OWNER_KEY) === normalizedEmail) return false;

  ClearUserSelectionCache();
  setLocalItem(SELECTION_OWNER_KEY, normalizedEmail);
  return true;
}
